import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import { DialogSettings, DialogTemplates } from '@quantium/common';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-http-error-dialog',
    templateUrl: './http-error-dialog.component.html'
})
export class HttpErrorDialogComponent {
    @Input() errorTitle: string;
    @Input() errorMessage: string;
    @Input() stackTrace: string;
    @Input() traceId: string;

    isErrorDetailCollapsed = true;

    dialogTemplate = DialogTemplates.HttpError;
    dialogSettings: DialogSettings;

    currEnvironment = environment;

    constructor(
        public activeModal: NgbActiveModal,
        private ngbModal: NgbModal,
        private clipboard: Clipboard
    ) {
        this.dialogSettings = new DialogSettings();
        this.dialogSettings.size = 'sm';
    }

    copyErrorMsgToClipboard(): void {
        this.clipboard.copy(`${this.errorTitle}\n${this.stackTrace}`);
    }
}
